<div class="default-dialog-wrapper mat-elevation-z10">
  <div class="flex flex-row content pt-20 pr-26 pb-20 pl-26">
    <div class="flex flex-col w-100-percent">
        <div class="flex flex-row justify-between mt-10">
          <mat-icon svgIcon="warning_amber" class="w-48 h-48 amber_color triangle-icon"></mat-icon>
          <mat-icon svgIcon="close" class="close-icon cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
        </div>
        <div class="flex justify-center fw-700 fs-24 title mt-16 mb-16" [innerHTML]="('REDIRECT_MSG.REDIRECT_TITLE' | transloco) + ' ' + redirectTitle"></div>
        <div class="fs-16 fs-400 mb-26 pl-4 pr-4 text-center whitespace-pre-line" [innerHTML]="('REDIRECT_MSG.MESSAGE' | transloco) + ' ' + redirectMsg"></div>
      <mat-divider class="neutral-blue-7 w-100-percent mt-4 mb-4"></mat-divider>
      <div class="flex flex-row justify-end w-100-percent mt-16">
        <button class="cancel-btn mr-12" [matDialogClose]="false">{{cancelButtonText}}</button>
        <button class="accent" (click)="dialogClose()">{{proceedButtonText}}</button>
      </div>
    </div>
  </div>
</div>
